/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Language_ThInputs */

const en_nav_language_th = /** @type {(inputs: Nav_Language_ThInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไทย`)
};

const es_nav_language_th = /** @type {(inputs: Nav_Language_ThInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไทย`)
};

const de_nav_language_th = /** @type {(inputs: Nav_Language_ThInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไทย`)
};

const zh_nav_language_th = /** @type {(inputs: Nav_Language_ThInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไทย`)
};

const ar_nav_language_th = /** @type {(inputs: Nav_Language_ThInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไทย`)
};

const fr_nav_language_th = /** @type {(inputs: Nav_Language_ThInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไทย`)
};

const vi_nav_language_th = /** @type {(inputs: Nav_Language_ThInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไทย`)
};

const sw_nav_language_th = /** @type {(inputs: Nav_Language_ThInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไทย`)
};

const th_nav_language_th = /** @type {(inputs: Nav_Language_ThInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไทย`)
};

const bs_nav_language_th = /** @type {(inputs: Nav_Language_ThInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไทย`)
};

const ja_nav_language_th = /** @type {(inputs: Nav_Language_ThInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไทย`)
};

const ko_nav_language_th = /** @type {(inputs: Nav_Language_ThInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไทย`)
};

const pt_nav_language_th = /** @type {(inputs: Nav_Language_ThInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไทย`)
};

const it_nav_language_th = /** @type {(inputs: Nav_Language_ThInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไทย`)
};

const sv_nav_language_th = /** @type {(inputs: Nav_Language_ThInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไทย`)
};

const nl_nav_language_th = /** @type {(inputs: Nav_Language_ThInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไทย`)
};

const da_nav_language_th = /** @type {(inputs: Nav_Language_ThInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไทย`)
};

const nb_nav_language_th = /** @type {(inputs: Nav_Language_ThInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไทย`)
};

const fi_nav_language_th = /** @type {(inputs: Nav_Language_ThInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไทย`)
};

const pl_nav_language_th = /** @type {(inputs: Nav_Language_ThInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไทย`)
};

const ru_nav_language_th = /** @type {(inputs: Nav_Language_ThInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไทย`)
};

const tr_nav_language_th = /** @type {(inputs: Nav_Language_ThInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไทย`)
};

const hi_nav_language_th = /** @type {(inputs: Nav_Language_ThInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไทย`)
};

const id_nav_language_th = /** @type {(inputs: Nav_Language_ThInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไทย`)
};

const ms_nav_language_th = /** @type {(inputs: Nav_Language_ThInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไทย`)
};

const cs_nav_language_th = /** @type {(inputs: Nav_Language_ThInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไทย`)
};

const el_nav_language_th = /** @type {(inputs: Nav_Language_ThInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไทย`)
};

const he_nav_language_th = /** @type {(inputs: Nav_Language_ThInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไทย`)
};

const af_nav_language_th = /** @type {(inputs: Nav_Language_ThInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไทย`)
};

const hu_nav_language_th = /** @type {(inputs: Nav_Language_ThInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไทย`)
};

/**
* | output |
* | --- |
* | "ไทย" |
*
* @param {Nav_Language_ThInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_language_th = /** @type {((inputs?: Nav_Language_ThInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Language_ThInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_language_th(inputs)
	if (locale === "de") return de_nav_language_th(inputs)
	if (locale === "zh") return zh_nav_language_th(inputs)
	if (locale === "ar") return ar_nav_language_th(inputs)
	if (locale === "fr") return fr_nav_language_th(inputs)
	if (locale === "vi") return vi_nav_language_th(inputs)
	if (locale === "sw") return sw_nav_language_th(inputs)
	if (locale === "th") return th_nav_language_th(inputs)
	if (locale === "bs") return bs_nav_language_th(inputs)
	if (locale === "ja") return ja_nav_language_th(inputs)
	if (locale === "ko") return ko_nav_language_th(inputs)
	if (locale === "pt") return pt_nav_language_th(inputs)
	if (locale === "it") return it_nav_language_th(inputs)
	if (locale === "sv") return sv_nav_language_th(inputs)
	if (locale === "nl") return nl_nav_language_th(inputs)
	if (locale === "da") return da_nav_language_th(inputs)
	if (locale === "nb") return nb_nav_language_th(inputs)
	if (locale === "fi") return fi_nav_language_th(inputs)
	if (locale === "pl") return pl_nav_language_th(inputs)
	if (locale === "ru") return ru_nav_language_th(inputs)
	if (locale === "tr") return tr_nav_language_th(inputs)
	if (locale === "hi") return hi_nav_language_th(inputs)
	if (locale === "id") return id_nav_language_th(inputs)
	if (locale === "ms") return ms_nav_language_th(inputs)
	if (locale === "cs") return cs_nav_language_th(inputs)
	if (locale === "el") return el_nav_language_th(inputs)
	if (locale === "he") return he_nav_language_th(inputs)
	if (locale === "af") return af_nav_language_th(inputs)
	if (locale === "hu") return hu_nav_language_th(inputs)
	return en_nav_language_th(inputs)
});